import React from 'react'
import { AddToWatchlistIcon, RemoveFromWatchlistIcon } from '~/assets/svg'
import './styles.scss'

const Sharing = ({ socialShare, toggleQueue, user, isQueued }) => {
  return (
    <div className='sharing_icons'>
      <i 
        className='ion-social-facebook' 
        onClick={() => { socialShare('Facebook') }} 
      />
      <i 
        className='ion-social-twitter' 
        onClick={() => { socialShare('Twitter') }} 
      />
      <i 
        className='ion-ios-email-outline' 
        onClick={() => { socialShare('Email') }}           
      />
      { user &&
        ( isQueued ? (
            <div className='remove-watchlist site-color' onClick={toggleQueue}>
              {' '}
              <RemoveFromWatchlistIcon />
            </div>
          ) : (
            <div className='add-watchlist site-color' onClick={toggleQueue}>
              {' '}
              <AddToWatchlistIcon />
            </div>
          )
        )
      }
    </div>
  )
}

export default Sharing


